import { render, staticRenderFns } from "./BattlesSpinner.vue?vue&type=template&id=2605cd4c&scoped=true"
import script from "./BattlesSpinner.vue?vue&type=script&lang=js"
export * from "./BattlesSpinner.vue?vue&type=script&lang=js"
import style0 from "./BattlesSpinner.vue?vue&type=style&index=0&id=2605cd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605cd4c",
  null
  
)

export default component.exports